import { getDicomVideoPoster } from '@/lib/dicom/dicomVideo';
import { useEffect, useState } from 'react';
/**
 * Returns a poster (first-frame) image URL for a DICOM video instance, decoded
 * client-side via ffmpeg.wasm. Returns null until ready (or on failure). The
 * underlying poster is cached per storage location and shared across callers,
 * so the object URL is intentionally not revoked here.
 */
export function useDicomVideoPoster(storageLocation) {
    // Tag the decoded poster with the storageLocation it belongs to. We derive
    // staleness during render (below) rather than clearing state in the effect, so
    // a caller never shows a stale frame when storageLocation changes or clears.
    const [entry, setEntry] = useState(null);
    useEffect(() => {
        if (!storageLocation)
            return;
        let active = true;
        getDicomVideoPoster(storageLocation)
            .then((url) => {
            if (active)
                setEntry({ loc: storageLocation, url });
        })
            .catch(() => {
            /* keep null — caller shows a placeholder */
        });
        return () => {
            active = false;
        };
    }, [storageLocation]);
    // Only surface the poster if it belongs to the current storageLocation.
    return entry && entry.loc === storageLocation ? entry.url : null;
}
